<h2>Notices</h2>
<ul *ngIf="announcements && announcements.length; else noAnnouncements;">
  <li *ngFor="let announcement of announcements">
    <p><strong>{{ announcement.lastUpdated | moment:'format':'D/M/YYYY hh:mma' }}</strong>
    </p>
    <markdown [data]="announcement.body"></markdown>
  </li>
</ul>
<ng-template #noAnnouncements>
  <ul>
    <li>
      <p><strong>No current notices</strong></p>
    </li>
  </ul>
</ng-template>